import React, { useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid2';
import "./homepage.css";
import axios from "axios";
import ReviewCarosel from '../../components/carosel/ReviewCarosel';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faFileLines } from '@fortawesome/free-regular-svg-icons';
import { apiService } from '../../services/apiService';
import PhoneInput from 'react-phone-number-input';
import { getCountryCallingCode } from 'libphonenumber-js';
import { toast } from 'react-toastify';
import Select from 'react-select';
function Homepage() {
    const [isJobSeekersActive, setIsJobSeekersActive] = useState(true);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [emailVerificationError, setEmailVerificationError] = useState('');
    const [emailVerified, setEmailVerified] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [isVerifying2, setIsVerifying2] = useState(false);
    const [otpResendTimer, setOtpResendTimer] = useState(0);
    const [timerActive, setTimerActive] = useState(false);
    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = { 
        US: 10,  // United States
        IN: 10,  // India
        CA: 10,  // Canada
        DE: 11,  // Germany
        AU: 9,   // Australia
        GB: 10,  // United Kingdom
        PK: 10   // Pakistan
    };
    const handleJobSeekersClick = () => {
        setIsJobSeekersActive(true);
    };

    const handleEmployersClick = () => {
        setIsJobSeekersActive(false);
    };
    const [generalData, setgeneraldata] = useState([]);
    const [caseListData, setCaseList] = useState([]);
    const [selectedCaseId, setSelectedCaseId] = useState([]);
    const [sessionToken, setSessionToken] = useState("");
    useEffect(() => {
        const fetchsetsData = async () => {
        try {
            const response = await apiService.getRequest('/general-settings');
            if(response && response.success === true){
                setgeneraldata(response.data);
            }
        } catch (error) {
            console.error('Error', error);
        }
        };
        fetchsetsData();
    }, []);
    const [submitloader, setSubmitloader] = useState(false);
    const [formData, setFormData] = useState({
        Q0010: '',
        Q0020: '',
        Q0030: '',
        Q0060: '',
        Q0070: '',
        Q0090: '',
        Q0100: '',
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    
    useEffect(() => {
        if (sessionToken !== "") {
            const fetchRoles = async () => {
                try {
                    const response = await axios.post(
                        `${process.env.REACT_APP_BASE_URL}/intake/user-cases`,
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${sessionToken}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                    if (response && response.data.success) {
                        const options = response.data.data.map((role) => ({
                            value: role.id,
                            label: role.case_number,
                        }));
                        setCaseList(options);
                    }
                } catch (error) {
                    console.error("Error fetching roles:", error);
                }
            };

            fetchRoles();
        }
    }, [sessionToken]);
    const handlePhoneChange = (value) => {
        if (value) {
            const country = allowedCountries.find(
            (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
            ) || 'US';
    
            const maxLength = maxPhoneLengths[country];
    
            // Strip the country code and check the actual phone number length
            const phoneWithoutCode = value.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
            
            if (phoneWithoutCode.length <= maxLength) {
            handleInputChange({ target: { name: "Q0070", value } });
            }
        } else {
            handleInputChange({ target: { name: "Q0070", value: '' } });
        }
    };
    const handleKeyDown2 = (event) => {
        const { key } = event;
        const currentValue = formData.Q0070 || '';
        const country = allowedCountries.find(
            (c) => currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';
    
        const maxLength = maxPhoneLengths[country];
    
        // Remove country code and check the actual phone number length
        const phoneWithoutCode = currentValue.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
    
        if (phoneWithoutCode.length >= maxLength && /\d/.test(key)) {
            event.preventDefault(); // Stop further input
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        if (name === 'Q0060') {
            setEmailVerificationError('');
            setOtpSent(false);
        }
        setFormData({ ...formData, [name]: value });
    };
    const handleCaseChange = (selectedOptions) => {
        // const selectedValues = selectedOptions.map(option => option.value);
        setSelectedCaseId(selectedOptions);
        setFormData({ ...formData, Q0100: selectedOptions.value });

        // Clear the Ownedby Group error when a group is selected
        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0100: '',
        }));
    };  
    useEffect(() => {
        let interval;
        if (timerActive && otpResendTimer > 0) {
            interval = setInterval(() => {
            setOtpResendTimer((prevTime) => prevTime - 1);
            }, 1000);
        } else if (otpResendTimer === 0) {
            setTimerActive(false);
            setEmailVerificationError("");
        }
        return () => clearInterval(interval);
        }, [timerActive, otpResendTimer]);
    
        const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };
    useEffect(() => { 
        const fetchData = async () => {
            const response = await apiService.postRequest(`profile`);
            if (response.success) {
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.removeItem('token');
                    localStorage.removeItem('impersonate');
                    localStorage.removeItem('docuTemplateId')
                    localStorage.removeItem('role');
                    localStorage.removeItem('userid');
                    localStorage.removeItem('usernames');
                    localStorage.removeItem('permissions');
                    localStorage.removeItem('hasReloaded');
                    localStorage.removeItem('authenti');  
                    localStorage.removeItem('notifications');  
                    localStorage.removeItem('onBoardTaskID');
                    localStorage.removeItem('onboardingSlugs'); 
                    localStorage.removeItem('onboardUserId');
                }
            }
        };
        fetchData();
    }, []);
    
    // Send OTP API call
    const handleSendOtp = async () => {
        setIsVerifying(true);
        try {
            const response = await apiService.postRequest('auth/send-otp/external', { email: formData.Q0060 });
            if (response && response.success) {
                setOtpSent(true);
                setErrors({});
                setEmailVerificationError('');
                toast("OTP sent to Your Email!");
                setTimerActive(false);
            }else {
                setEmailVerificationError(response.message);
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.remaining_seconds){
                    setTimerActive(true);
                    setOtpResendTimer(response.remaining_seconds);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            } 
        } catch (error) {
            console(error,"err")
        }finally {
            setIsVerifying(false);
        }
    };
    // Verify OTP API call
    const handleVerifyOtp = async () => {
        setIsVerifying2(true);
        try {
            const response = await apiService.postRequest('auth/verify-otp', { email: formData.Q0060, otp, phone: formData.Q0070 });
            if (response && response.success) {
                setSessionToken(response.session_token)
                setEmailVerified(true);
                setOtpError('');
                setErrors({});
                setTimerActive(false);
                setOtpResendTimer(0);
                setEmailVerificationError("");
            } else {
                if (response.errors) {
                    setErrors(response.errors);
                }
                setOtpError(response.message);
                setEmailVerified(false);
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            setOtpError('An unexpected error occurred during OTP verification.');
        }finally {
            setIsVerifying2(false);
        }
    };
    

    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const MAX_FILES = 20;
    const MAX_TOTAL_SIZE_MB = 200;
    const MAX_FILE_SIZE_MB = 10;
    const MAX_VIDEO_SIZE_MB = 200; // Special limit for video files
    const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif',
        'application/pdf',
        'text/csv',
        'text/plain',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', // xls files
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx files
        'video/mp4',
        'video/webm',
        'video/ogg',
    ];

    const videoTypes = ['video/mp4', 'video/webm', 'video/ogg'];

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        // Check if total number of files exceeds limit
        if (files.length + selectedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0080: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of selectedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Only image files (JPEG, PNG, GIF), CSV, PDF, XLS, XLSX, MP4, WEBM, OGG , TXT, DOC and DOCX are allowed..`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = selectedFiles.some(file => videoTypes.includes(file.type)) || files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file?.size, 0);
            const newSize = selectedFiles.reduce((acc, file) => acc + file?.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }
        
        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0080: "",
        }));
        
        const updatedFiles = selectedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
        fileInputRef.current.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);

        // Check if total number of files exceeds limit
        if (files.length + droppedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0080: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of droppedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Only image files (JPEG, PNG, GIF), CSV, PDF, XLS, XLSX, MP4, WEBM, OGG , TXT, DOC and DOCX are allowed..`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = droppedFiles.some(file => videoTypes.includes(file.type)) || 
                        files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
            const newSize = droppedFiles.reduce((acc, file) => acc + file.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0080: "",
        }));
        
        const updatedFiles = droppedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
    };

    const handleRemoveFile = (index) => {
        
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        fileInputRef.current.value = null;
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.Q0010) newErrors.Q0010 = "Name is required.";
        if (formData.Q0010 && formData.Q0010.length < 3) {
            newErrors.Q0010 = "Name must be at least 3 characters long.";
        }else if (formData.Q0010 && formData.Q0010.length > 160) {
            newErrors.Q0010 = 'Name must be less than 160 characters long.';
        }

        if (!formData.Q0020) newErrors.Q0020 = "Short description is required.";
        if (formData.Q0020 && formData.Q0020.length < 3) {
            newErrors.Q0020 = "Short description must be at least 3 characters long.";
        }else if (formData.Q0020 && formData.Q0020.length > 200) {
            newErrors.Q0020 = 'Short description be less than 200 characters long.';
        }

        if (!formData.Q0030) newErrors.Q0030 = "Description is required.";
        if (formData.Q0030 && formData.Q0030.length < 3) {
            newErrors.Q0030 = "Description must be at least 3 characters long.";
        }else if (formData.Q0030 && formData.Q0030.length > 2000) {
            newErrors.Q0030 = 'Description be less than 2000 characters long.';
        }

        if (!formData.Q0060) newErrors.Q0060 = "Contact email is required.";
        if (!formData.Q0070) newErrors.Q0070 = "Contact phone is required.";
        if (!formData.Q0090) newErrors.Q0090 = "Submitted a case for this inquiry before is required.";
        if(formData.Q0090 === "Yes"){
            if (!formData.Q0100) newErrors.Q0100 = "Case number is required.";
            if (formData.Q0100 && formData.Q0100.length < 3) {
                newErrors.Q0100 = "Case number must be at least 3 characters long.";
            }else if (formData.Q0100 && formData.Q0100.length > 10) {
                newErrors.Q0100 = 'Case number be less than 10 characters long.';
            }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
            const formDataToSend = new FormData();

            // Add file attachments
            files.forEach((file) => {
                formDataToSend.append('Q0080[]', file.file);
            });

            // Add other form fields
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null) {
                    formDataToSend.append(key, formData[key]);
                }
            }
            const response = await apiService.postRequest('cases/intake-request', formDataToSend);

            // Check if the response indicates success
            if (response && response.success === true) {
                setErrors({});
                setErrorMessage('');
                setFiles([]);
                setEmailVerified(false);
                setTimerActive(false);
                setIsVerifying(false);
                setIsVerifying2(false);
                setOtpSent(false);
                setOtpResendTimer(0);
                setOtp('');
                setOtpError('');
                setEmailVerificationError('');
                setSessionToken('');
                setCaseList([]);
                setSelectedCaseId([]);
                setFormData({
                    Q0010: '',
                    Q0020: '',
                    Q0030: '',
                    Q0060: '',
                    Q0070: '',
                    Q0090: '',
                    Q0100: '',
                });

                toast(response.message || "Submitted Successfully !")
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };
  return (
    <>
    <Header generalData={generalData}/>
    <Grid container size={{xs:12}} justifyContent="center">
        <Grid container size={{xs:12}} justifyContent="center" className="hero_section mb-5" alignContent="center">
            <Grid container size={{lg:12,md:12,sm:10,xs:11}} justifyContent="center">
                <h1 className='d-lg-block d-none'>Take Control of your Job Search<br/>and Hiring Today</h1>
                <h1 className='d-lg-none'>Take Control of your<br/> Job Search and <br/>Hiring Today</h1>
            </Grid>
            <Grid container size={{lg:8,md:8,sm:11,xs:11}} justifyContent="center" alignItems="center" flexDirection="column">
                <h3>Simplify Your Job Search and Hiring Process with BenchTrack</h3>
                <span>Streamline your recruitment efforts and discover top talent effortlessly with our cutting-edge job consultancy app.</span>
                <button>Enquire Now</button>
            </Grid>
            <img className='hero_float1' src={require('../../assets/hero_float1.png')} alt=''/>
            <img className='hero_float2' src={require('../../assets/hero_float2.png')} alt=''/>
            <img className='hero_float3 d-lg-block d-none' src={require('../../assets/hero_float3.png')} alt=''/>
            <img className='hero_float4 d-lg-block d-none' src={require('../../assets/hero_float4.png')} alt=''/>
            <img className='hero_float5' src={require('../../assets/hero_float5.png')} alt=''/>
            <img className='hero_float6' src={require('../../assets/hero_float6.png')} alt=''/>
        </Grid>
        <Grid container size={{xs:12}} justifyContent="center" className="why_choosebench">
            <Grid size={{xs:11}} container justifyContent="center">
                <h1>Why Choose BenchTrack?</h1>
            </Grid>
            <Grid size={{lg:8,md:10,xs:11}} container justifyContent="space-evenly" alignItems="center" alignContent="center" className="flex-md-row-reverse">
                <Grid size={{sm:4,xs:12}} container alignItems="center" className="imghover_hiders">
                    <img src={require('../../assets/second_hero.png')} alt=''/>
                </Grid>
                <Grid size={{sm:7,xs:12}} container justifyContent="center" alignContent="center">
                    <Grid size={{xs:12}} container className="whitewhy_body" flexDirection="column">
                        <h5>Efficient Job Matching</h5>
                        <small>Our advanced algorithms match job seekers with the most suitable opportunities, ensuring both candidates and employers find their perfect fit.</small>
                    </Grid>
                    <Grid size={{xs:12}} container className="whitewhy_body" flexDirection="column">
                        <h5>Real-Time Updates</h5>
                        <small>Stay ahead with real-time notifications about new job listings, candidate applications, and interview schedules, all within the app.</small>
                    </Grid>
                    <Grid size={{xs:12}} container className="whitewhy_body" flexDirection="column">
                        <h5>Comprehensive Analytics</h5>
                        <small>Track your hiring process with detailed analytics and reports, making informed decisions easier than ever.</small>
                    </Grid>
                    <Grid size={{xs:12}} container className="whitewhy_body" flexDirection="column">
                        <h5>User-Friendly Interface</h5>
                        <small>Designed with simplicity in mind, Bench Track offers a seamless experience for both job seekers and employers.</small>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        <Grid container size={{xs:12}} justifyContent="center" className="key_featuremain">
            <Grid size={{xs:11}} container justifyContent="center" className="mt-4">
                <h1>Key Features</h1>
            </Grid>
            <Grid size={{xs:12}} container justifyContent="center">
                <div className='button_keyfeatures'>
                    <button className={isJobSeekersActive ? 'activekeyfeture' : ''} onClick={handleJobSeekersClick}>Job Seekers</button>
                    <button className={!isJobSeekersActive ? 'activekeyfeture' : ''} onClick={handleEmployersClick}>Employers</button>
                </div>
            </Grid>
            {isJobSeekersActive ? 
            <Grid size={{ lg:8,md:10,xs:11}} container justifyContent="space-between" className="mt-4 mb-5">
                <Grid size={{sm:3.8}} container justifyContent="flex-start" flexDirection="column" className="card_keyfeature my-2">
                    <img src={require('../../assets/keyfeatureicon/icon1.svg').default} alt=''/>
                    <h5>Smart Job Search</h5>
                    <small>Filter and find job openings that match your skills and preferences.</small>
                </Grid>
                <Grid size={{sm:3.8}} container justifyContent="flex-start" flexDirection="column" className="card_keyfeature my-2">
                    <img src={require('../../assets/keyfeatureicon/icon2.svg').default} alt=''/>
                    <h5>Instant Notifications</h5>
                    <small>Receive alerts for new job postings, application status, and interview schedules.</small>
                </Grid>
                <Grid size={{sm:3.8}} container justifyContent="flex-start" flexDirection="column" className="card_keyfeature my-2">
                    <img src={require('../../assets/keyfeatureicon/icon3.svg').default} alt=''/>
                    <h5>Profile Management</h5>
                    <small>Create and update your profile effortlessly, showcasing your experience and skills.</small>
                </Grid>
            </Grid>
            :
            <Grid size={{lg:8,md:10,xs:11}} container justifyContent="space-between" className="mt-4 mb-5">
                <Grid size={{sm:3.8}} container justifyContent="flex-start" flexDirection="column" className="card_keyfeature my-2">
                    <img src={require('../../assets/keyfeatureicon/icon4.svg').default} alt=''/>
                    <h5>Candidate Tracking</h5>
                    <small>Manage your candidate pipeline with ease, from application to hiring.</small>
                </Grid>
                <Grid size={{sm:3.8}} container justifyContent="flex-start" flexDirection="column" className="card_keyfeature my-2">
                    <img src={require('../../assets/keyfeatureicon/icon5.svg').default} alt=''/>
                    <h5>Customizable Job Listings</h5>
                    <small>Manage your candidate pipeline with ease, from application to hiring.</small>
                </Grid>
                <Grid size={{sm:3.8}} container justifyContent="flex-start" flexDirection="column" className="card_keyfeature my-2">
                    <img src={require('../../assets/keyfeatureicon/icon6.svg').default} alt=''/>
                    <h5>Interview Scheduling</h5>
                    <small>Coordinate interview times and communicate directly with candidates.</small>
                </Grid>
            </Grid>
            }
        </Grid>
        <Grid container size={{xs:12}} justifyContent="center" className="trackworkmain">
            <Grid size={{xs:11}} container justifyContent="center">
                <h1>How Bench Track Works</h1>
            </Grid>
            <Grid container className="w-100 d-md-block d-none">
                <Grid container size={{xs:12}} justifyContent="center">
                    <Grid size={{xs:11}} container justifyContent="center">
                        <Grid size={{lg:3,md:5,sm:5.5}} container className="maintrackminset" alignItems="flex-start">
                            <Grid size={{xs:12}} container className="mintrack_height" alignContent="space-between">
                                <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                                    <Grid size={{sm:2}} container justifyContent="flex-end" alignItems="flex-start">
                                        <img className='mt-2' src={require('../../assets/trackicons/icon1.svg').default} alt=''/>
                                    </Grid>
                                    <Grid size={{sm:7}} container className="arow_traccontent">
                                        <h5>Sign Up</h5>
                                        <small>Register quickly as a job seeker or employer to get started.</small>
                                    </Grid>
                                    <Grid size={{sm:3}} className="mb-2" container justifyContent="flex-start" alignItems="flex-end">
                                        <img src={require('../../assets/trackicons/arrow1.svg').default} alt=''/>
                                    </Grid>
                                </Grid>
                                <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                                    <Grid size={{sm:2}} container justifyContent="flex-end" alignItems="flex-start">
                                        <img className='mt-2' src={require('../../assets/trackicons/icon3.svg').default} alt=''/>
                                    </Grid>
                                    <Grid size={{sm:7}} container className="arow_traccontent">
                                        <h5>Connect</h5>
                                        <small>Job seekers apply directly through the app, while employers review and manage candidates.</small>
                                    </Grid>
                                    <Grid size={{sm:3}} className="mb-2" container justifyContent="flex-start" alignItems="flex-end">
                                        <img src={require('../../assets/trackicons/arrow3.svg').default} alt=''/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container className="dash_linetrack"/>
                        <Grid size={{lg:3,md:5,sm:5.5}} container className="maintrackminset" alignItems="flex-end">
                            <Grid size={{xs:12}} container className="mintrack_height" alignContent="space-between">
                                <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                                    <Grid size={{sm:3}} className="mb-2" container justifyContent="flex-end" alignItems="flex-end">
                                        <img src={require('../../assets/trackicons/arrow2.svg').default} alt=''/>
                                    </Grid>
                                    <Grid size={{sm:7}} container className="arow_traccontent">
                                        <h5>Explore</h5>
                                        <small>Browse through job listings or search for top talent based on your requirements.</small>
                                    </Grid>
                                    <Grid size={{sm:2}} container justifyContent="flex-start" alignItems="flex-start">
                                        <img className='mt-2' src={require('../../assets/trackicons/icon2.svg').default} alt=''/>
                                    </Grid>
                                </Grid>
                                <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                                    <Grid size={{sm:3}} className="mb-2" container justifyContent="flex-end" alignItems="flex-end">
                                        <img src={require('../../assets/trackicons/arrow4.svg').default} alt=''/>
                                    </Grid>
                                    <Grid size={{sm:7}} container className="arow_traccontent">
                                        <h5>Hire or Get Hired</h5>
                                        <small>Streamline your hiring process or land your dream job with Bench Track.</small>
                                    </Grid>
                                    <Grid size={{sm:2}} container justifyContent="flex-start" alignItems="flex-start">
                                        <img className='mt-2' src={require('../../assets/trackicons/icon4.svg').default} alt=''/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container className="w-100 d-md-none">
                <Grid container size={{xs:12}} justifyContent="center">
                    <Grid size={{xs:11}} container justifyContent="space-evenly" className="">
                        <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                            <Grid size={{xs:1.5}} container justifyContent="flex-end" alignItems="flex-start">
                                <img className='mt-2' src={require('../../assets/trackicons/icon1.svg').default} alt=''/>
                            </Grid>
                            <Grid size={{xs:8}} container className="arow_traccontent">
                                <h5>Sign Up</h5>
                                <small>Register quickly as a job seeker or employer to get started.</small>
                            </Grid>
                            <Grid size={{xs:2.5}} className="mb-2" container justifyContent="flex-start" alignItems="flex-end">
                                <img src={require('../../assets/trackicons/arrow1.svg').default} alt=''/>
                            </Grid>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                            <Grid size={{xs:1.5}} container justifyContent="flex-end" alignItems="flex-start">
                                <img className='mt-2' src={require('../../assets/trackicons/iconmobi2.svg').default} alt=''/>
                            </Grid>
                            <Grid size={{xs:8}} container className="arow_traccontent">
                                <h5>Explore</h5>
                                <small>Browse through job listings or search for top talent based on your requirements.</small>
                            </Grid>
                            <Grid size={{xs:2.5}} className="mb-2" container justifyContent="flex-start" alignItems="flex-end">
                                <img src={require('../../assets/trackicons/arrowmobi2.svg').default} alt=''/>
                            </Grid>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                            <Grid size={{xs:1.5}} container justifyContent="flex-end" alignItems="flex-start">
                                <img className='mt-2' src={require('../../assets/trackicons/icon3.svg').default} alt=''/>
                            </Grid>
                            <Grid size={{xs:8}} container className="arow_traccontent">
                                <h5>Connect</h5>
                                <small>Job seekers apply directly through the app, while employers review and manage candidates.</small>
                            </Grid>
                            <Grid size={{xs:2.5}} className="mb-2" container justifyContent="flex-start" alignItems="flex-end">
                                <img src={require('../../assets/trackicons/arrow3.svg').default} alt=''/>
                            </Grid>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="flex-start" className="content_trackprocess">
                            <Grid size={{xs:1.5}} container justifyContent="flex-end" alignItems="flex-start">
                                <img className='mt-2' src={require('../../assets/trackicons/iconmobi4.svg').default} alt=''/>
                            </Grid>
                            <Grid size={{xs:8}} container className="arow_traccontent">
                                <h5>Hire or Get Hired</h5>
                                <small>Streamline your hiring process or land your dream job with Bench Track.</small>
                            </Grid>
                            <Grid size={{xs:2.5}} className="mb-2" container justifyContent="flex-start" alignItems="flex-end">
                                <img src={require('../../assets/trackicons/arrowmobi4.svg').default} alt=''/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        <Grid container size={{xs:12}} justifyContent="center" className="sucess_story">
            <Grid size={{xs:12}} container justifyContent="center">
                <h1>Success Stories</h1>
            </Grid>
            <Grid size={{md:8,xs:11}} container justifyContent="center">
                <ReviewCarosel/>
            </Grid>
        </Grid>
        <Grid container size={{xs:12}} justifyContent="center" className="contact_usreport py-4">
            <Grid size={{xs:11}} container justifyContent="center" className="reporthomemain my-2">
                <h1>Contact Us</h1>
                <h5>Please fill the form if any problem</h5>
                <Grid size={{sm:11,xs:11}} container>
                    <form className='w-100' 
                    onSubmit={handleSubmit}
                    >
                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs">
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Full name<span style={{color:"red"}}> *</span></span>
                                <input value={formData.Q0010} onChange={handleInputChange}
                                    type="text"
                                    name="Q0010"
                                    maxLength="161"
                                />
                                {errors.Q0010 && <p style={{color:"Red"}}>{errors.Q0010}</p>}
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Phone Number<small className='red_starimpo'>*</small></span>
                                <PhoneInput
                                    className='phone_input_imgs'
                                    placeholder="Enter phone number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={false}
                                    limitMaxLength={true}
                                    value={formData.Q0070}
                                    onChange={handlePhoneChange}
                                    onKeyDown={handleKeyDown2}
                                    autoComplete="new-password"
                                />
                                {errors.Q0070 && <p style={{color:"Red"}}>{errors.Q0070}</p>}
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Email<span style={{color:"red"}}> *</span></span>
                                <input value={formData.Q0060} disabled={emailVerified} onChange={handleInputChange}
                                    type="text"
                                    name="Q0060"
                                />
                                {errors.Q0060 && <p style={{color:"Red"}}>{errors.Q0060}</p>}
                                {emailVerificationError && <p style={{ color: 'red' }}>{emailVerificationError}</p>}
                            </Grid>
                            <Grid size={{md:5.5, sm:5.8, xs:12}} container alignItems="flex-start">
                                {(!otpSent && !emailVerificationError) && (
                                    <button type="button" className='registersendbtn2 mt-5 mb-0' onClick={handleSendOtp}>
                                        {isVerifying ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Get OTP'}
                                    </button>
                                )}
                                {timerActive ?
                                    <small className='resend_otpsmallTimer mt-md-5 mt-2 ps-3 mb-0'>{timerActive ? `Resend OTP in ${formatTime(otpResendTimer)}` : ''}</small>:<>
                                    {otpSent && (emailVerified === false) ? (
                                        <button className='registersendbtn1 mt-md-5 mt-2 mb-0 px-0' type="button" onClick={handleSendOtp}>
                                            {isVerifying ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : 'Resend OTP'}
                                        </button>
                                    ) : (emailVerified === true) ? <small className='verified_small mt-md-5 mt-2 pt-2 mb-0'><FontAwesomeIcon icon={faCircleCheck} /> Verified</small> : ""}
                                </>}
                            </Grid>
                            {(otpSent) && (emailVerified === false) ?  (
                                <>
                                <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                    <span>Enter OTP ( Sent to Email )<small className='red_starimpo'>*</small></span>
                                    <input
                                        type="text"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        placeholder="------" maxLength={6} className='otp_input'
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    />
                                </Grid>
                                <Grid size={{md:5.5, sm:5.8, xs:12}} container alignItems="flex-end">
                                <button type="button" className='registersendbtn2 mb-2' onClick={handleVerifyOtp}>{isVerifying2 ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Verify OTP'}</button>
                                {otpError && <p style={{ color: 'red',marginLeft:'10px' }}>{otpError}</p>}
                            </Grid>
                            </>
                            ):""}
                            <Grid size={{ xs:12}} container>
                                <Grid size={{xs:12}} container flexDirection="column">
                                    <span>Short Description<span style={{color:"red"}}> *</span></span>
                                    <input value={formData.Q0020} onChange={handleInputChange}
                                        type="text"
                                        name="Q0020"
                                        maxLength="201"
                                    />
                                    {errors.Q0020 && <p style={{color:"Red"}}>{errors.Q0020}</p>}
                                </Grid>
                            </Grid>
                            <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                <span>Description<span style={{color:"Red"}}> *</span></span>
                                <textarea placeholder='Describe' maxLength="2001" value={formData.Q0030} onChange={handleInputChange} rows="10" name="Q0030"/>
                                {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                            </Grid>
                            <Grid size={{xs:12}} container flexDirection="column">
                                <span>Attachments</span>
                                <Grid size={{xs: 12 }} container justifyContent="space-between">
                                    <div
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                        className='drag_uploaders align-items-center flex-column d-flex'
                                    >
                                        <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                                        <input
                                            type="file"
                                            multiple
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                            id="file-upload"
                                            ref={fileInputRef} // Attach the ref here
                                        />
                                        <label htmlFor="file-upload">
                                            Browse Files
                                        </label>
                                        <p className='w-100 mb-0 mt-3'>or drop file here</p>
                                    </div>
                                    {errors.Q0080 && <div style={{ color: 'red', margin: '10px 0px' }}>{errors.Q0080}</div>}
                                </Grid>
                                <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4">
                                    {files.map((file, index) => (
                                        <Grid key={index} size={{xs:12}} container justifyContent="space-between" alignItems="center" className="tablelisterattach reportincident">
                                            <Grid container className="pinkbgattachreport" alignItems="center">
                                                <span className='spanreport_elipse' style={{whiteSpace: "nowrap"}}>{index + 1}<span className='filenamesshow ms-3'>{file.name}</span></span>
                                                <button onClick={(e) => handleRemoveFile(index)}>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </button>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                <span>Have you submitted a case for this inquiry before ?<span style={{color:"Red"}}> *</span></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        className='ms-0'
                                        // disabled={!showSubmits}
                                        type="radio" 
                                        name="Q0090"
                                        value="Yes"
                                        checked={formData.Q0090  === "Yes"} 
                                        onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        className='ms-4'
                                        // disabled={!showSubmits}
                                        type="radio" 
                                        name="Q0090"
                                        value="No"
                                        checked={formData.Q0090  === "No"} 
                                        onChange={handleInputChange} 
                                    />No
                                </div>
                                {errors.Q0090 && <p style={{color:"Red"}}>{errors.Q0090}</p>}
                            </Grid>
                            {formData.Q0090  === "Yes" &&
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="regiter_inputs">
                                <span>Add case number<span style={{color:"red"}}> *</span></span>
                                <Select
                                    name="case_type_id"
                                    value={selectedCaseId}
                                    onChange={handleCaseChange}
                                    options={caseListData}
                                    className="basic-multi-select select_withsearch w-100"
                                    classNamePrefix="select"
                                    placeholder="Choose case number..."
                                />
                                {/* <input value={formData.Q0100} onChange={handleInputChange}
                                    type="text"
                                    name="Q0100"
                                    maxLength="11"
                                /> */}
                                {errors.Q0100 && <p style={{color:"Red"}}>{errors.Q0100}</p>}
                            </Grid>
                            }
                            {errorMessage && <div style={{ color: 'red', margin: '10px 0px', width:"100%" }}>{errorMessage}</div>}
                            <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="mt-2">
                                {!emailVerified ?
                                <button type="submit" disabled className='disabled_btnapply my-5'>Submit</button>:
                                <button type="submit" disabled={!emailVerified} className='registersendbtn2 my-5'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                                }
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </Grid>
    </Grid>
    <Footer generalData={generalData}/>
    </>
  )
}

export default Homepage
